export default "__VITE_ASSET__BnGWGnTF__"